type TcPopinArgs = {
  popin_name: string
}

export default function tcPopin(data: TcPopinArgs) {
  if (
    !(window as typeof window & { tC: any })?.tC ||
    typeof (window as typeof window & { tC: any })?.tC?.event?.popin !==
      'function'
  ) {
    return
  }
  const { popin_name } = data
  try {
    ;(window as typeof window & { tC: any })?.tC?.event?.popin?.(undefined, {
      undefined,
      popin_name,
    })
  } catch (err) {
    console.log(err)
  }
}
